<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <slot></slot>
              <div class="card-tools">
                <div class="d-flex filter-container" style="width: 300px">
                  <b-skeleton type="input" class="mr-3 w-25"> </b-skeleton>
                  <b-skeleton type="input" class="w-75"></b-skeleton>
                </div>
              </div>
            </div>
            <div class="card-body table-responsive p-0">
              <b-skeleton-table
                :rows="8"
                :columns="5"
              ></b-skeleton-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TableSkeleton",
};
</script>